module.exports = __webpack_public_path__ + "static/media/sports3.f36c4af4.jpg";